import * as React from 'react';
import { withRouter } from 'react-router';
import { observer } from 'mobx-react';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkIllustrations } from 'uitk-react-illustrations';

const UnsubscribeCompleteComponent: React.FunctionComponent = observer(
  // tslint:disable-next-line:no-shadowed-variable
  function UnsubscribeCompleteComponent(): JSX.Element {
    // TODO - localise text
    return (
      <UitkSpacing className="container--small-1" padding={{ block: 'twelve' }}>
        <main className="Unsubscribe__container">
          <UitkLayoutFlex direction="column" alignItems="start" justifyContent="space-between" wrap="wrap">
            <UitkLayoutFlexItem alignSelf="center">
              <UitkSpacing margin={{ block: 'three' }}>
                <UitkIllustrations alt="Complete" url="/images/icons/deck_chair.svg" className="unsubscribeIcon" />
              </UitkSpacing>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem alignSelf="center">
              <UitkSpacing margin={{ block: 'three' }}>
                <UitkHeading tag="h1" size={4}>
                  You have been unsubscribed
                </UitkHeading>
              </UitkSpacing>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <UitkSpacing margin={{ block: 'three' }}>
                <UitkText>
                  We&apos;re sorry to see you go. Please keep in mind that it may take up to two days for your request
                  to be fully processed. Don&apos;t forget that you&apos;ll still receive important service emails.
                </UitkText>
              </UitkSpacing>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </main>
      </UitkSpacing>
    );
  },
);

export const UnsubscribeComplete = withRouter(UnsubscribeCompleteComponent);
